import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Challenge } from 'src/types/shared/Challenge';

export const postMarkChallengeAsAssessmentCompleteRequest = createAction(
    'postMarkChallengeAsAssessmentCompleteRequest',
);
export const postMarkChallengeAsAssessmentCompleteSuccess = createAction<Challenge>(
    'postMarkChallengeAsAssessmentCompleteSuccess',
);
export const postMarkChallengeAsAssessmentCompleteFailure = createAction(
    'postMarkChallengeAsAssessmentCompleteFailure',
);

export const postMarkChallengeAsAssessmentComplete = (challengeID: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(postMarkChallengeAsAssessmentCompleteRequest());
    try {
        const { data }: { data: Challenge } = await api.post(
            `admin/challenges/${challengeID}/assessment-complete`,
            {},
        );

        dispatch(postMarkChallengeAsAssessmentCompleteSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, postMarkChallengeAsAssessmentCompleteFailure, e);
    }
};
